import { useFonts } from "expo-font";
import { Inter_100Thin } from "@expo-google-fonts/inter/100Thin";
import { Inter_200ExtraLight } from "@expo-google-fonts/inter/200ExtraLight";
import { Inter_300Light } from "@expo-google-fonts/inter/300Light";
import { Inter_400Regular } from "@expo-google-fonts/inter/400Regular";
import { Inter_500Medium } from "@expo-google-fonts/inter/500Medium";
import { Inter_600SemiBold } from "@expo-google-fonts/inter/600SemiBold";
import { Inter_700Bold } from "@expo-google-fonts/inter/700Bold";
import { Inter_800ExtraBold } from "@expo-google-fonts/inter/800ExtraBold";

export const useAppFont = () => {
  return useFonts({
    "Inter-Thin": Inter_100Thin,
    "Inter-ExtraLight": Inter_200ExtraLight,
    "Inter-Light": Inter_300Light,
    "Inter-Regular": Inter_400Regular,
    "Inter-Medium": Inter_500Medium,
    "Inter-SemiBold": Inter_600SemiBold,
    "Inter-Bold": Inter_700Bold,
    "Inter-ExtraBold": Inter_800ExtraBold,
    "InterTight-Light": require("../assets/fonts/InterTight-Light.ttf"),
    "InterTight-ExtraLight": require("../assets/fonts/InterTight-ExtraLight.ttf"),
    "InterTight-Regular": require("../assets/fonts/InterTight-Regular.ttf"),
    "InterTight-Medium": require("../assets/fonts/InterTight-Medium.ttf"),
    "InterTight-SemiBold": require("../assets/fonts/InterTight-SemiBold.ttf"),
    "InterTight-Bold": require("../assets/fonts/InterTight-Bold.ttf"),
    "InterTight-ExtraBold": require("../assets/fonts/InterTight-ExtraBold.ttf"),
  });
};
